import { dataHooks } from '../../../libs/dataHooks';

export const forYouPageDataHooks = dataHooks<{
  genericPage;
}>('forYouPage');
